import PropTypes from "prop-types";
import IconCart from "../../icons/svgs/cart.svg";

import "./productRecommendationsButton/productRecommendationsButton.scss";

function ProductRecommendationsButton({ buttonText, onClick }) {
  return (
    <div className="recommendations-button-wrapper">
      <button type="button" className="recommendations-button" onClick={onClick}>
        <IconCart className="icon-cart" stroke="#2D2927" />
        <span className="recommendations-button-text">{buttonText}</span>
      </button>
      <span className="recommendations-button-aura" aria-hidden="true" />
    </div>
  );
}

ProductRecommendationsButton.propTypes = {
  buttonText: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default ProductRecommendationsButton;
